import { useState } from "react";
import { Option } from "react-select/lib/filters";
import { SelectPagination } from "@foris/avocado-suite";
import { CustomModelValue } from "@models/ISchema";
import useGetCustomModelValues from "@services/collections/custom-models/customModelsServices";

interface CustomModelSelectorProps {
  label?: string;
  placeholder?: string;
  scenario: string;
  origin?: string;
  selectedOption?: Option;
  clearSelectionOnChange?: boolean;
  isDisabled?: boolean;
  customModelCode: "SUBJECTS" | "CAMPUSES";
  getOptionLabel?: (option: CustomModelValue) => string;
  isOptionDisabled?: (option: any) => boolean;
  onChange?: (option: Option) => void;
}

const CustomModelSelector = ({
  label,
  placeholder,
  scenario,
  origin,
  selectedOption,
  clearSelectionOnChange = false,
  isDisabled = false,
  customModelCode,
  getOptionLabel,
  isOptionDisabled,
  onChange,
}: CustomModelSelectorProps) => {
  const [value, setValue] = useState(selectedOption);

  const { loadCustomModelValues } = useGetCustomModelValues({
    scenario,
    origin,
    customModelCode,
    getOptionLabel,
  });

  return (
    <SelectPagination
      label={label}
      value={value}
      loadOptions={loadCustomModelValues}
      placeholder={placeholder}
      onChange={option => {
        setValue(clearSelectionOnChange ? null : option);

        onChange?.(option);
      }}
      disabled={isDisabled}
      isOptionDisabled={isOptionDisabled}
    />
  );
};

export default CustomModelSelector;
